import React from 'react';
import { motion } from 'framer-motion';
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.2,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
export function ContactSection() {
  return <section id="contact" className="scroll-mt-24 pt-10 md:pt-16 pb-16 md:pb-32 px-6 md:px-14 bg-bg-warm relative z-10" data-id="element-15" data-mp="2khszv4oy0a9q">
      <motion.div initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={fadeUp} className="max-w-3xl mx-auto space-y-8 md:space-y-12" data-id="element-16" data-mp="3d81faos3ggkm">
        <h2 className="font-heading text-3xl md:text-6xl font-light text-primary leading-tight" data-id="element-17" data-mp="349zady58p3s2">
          Unwind in your <br data-id="element-18" data-mp="1sshgrrhdhkj9" /> new home
        </h2>

        <div className="space-y-4 md:space-y-6 text-base md:text-xl text-text-muted font-light leading-relaxed" data-id="element-19" data-mp="1srenjcwkv606">
          <p data-id="element-20" data-mp="1wuunai3y1mh3">
            Five bedrooms, 610 sqm, and a floor plan built around light and how
            you move through a day.
          </p>
          <p data-id="element-21" data-mp="2n1ukf9gi7nw">
            Campanilla offers a rare combination in Ayala Westgrove Heights:
            thoughtful architecture, generous living space, and a setting built
            for intentional living.
          </p>
          <p data-id="element-22" data-mp="ckq0808lozku">
            <span className="italic font-medium text-accent" data-id="element-23" data-mp="ck6h4g77s558">
              Schedule a private viewing with us.
            </span>
          </p>
        </div>

        <div className="pt-4 md:pt-8 space-y-5 md:space-y-6 text-primary" data-id="element-24" data-mp="llxmtl1r8bz3">
          <div className="flex items-center gap-6 border-b border-black/5 pb-4" data-id="element-25" data-mp="llny00sg4auz">
            <span className="text-xs tracking-widest font-medium w-20 text-text-muted" data-id="element-26" data-mp="10aakqnkek4w8">
              Mobile
            </span>
            <a href="tel:+639175260969" className="text-xl font-light hover:text-accent transition-colors" data-id="element-27" data-mp="ve3cup8g4jbn">
              0917 526 0969
            </a>
          </div>
          <div className="flex items-center gap-6 border-b border-black/5 pb-4" data-id="element-28" data-mp="14akso5rr95dq">
            <span className="text-xs tracking-widest font-medium w-20 text-text-muted" data-id="element-29" data-mp="1wwmjkzjw9qu">
              Email
            </span>
            <a href="mailto:inquiry@jrpdi.com" className="text-xl font-light hover:text-accent transition-colors" data-id="element-30" data-mp="azxs9kki7ytz">
              inquiry@jrpdi.com
            </a>
          </div>
        </div>

        <div className="pt-8 md:pt-12 flex flex-col items-center text-center" data-id="element-31" data-mp="kofp5qpnxlsc">
          <img src="https://cdn.magicpatterns.com/uploads/1XQazF3bMRoBsuVY3Rx58f/2.png" alt="JRP" className="h-10 md:h-12 w-auto" data-id="element-32" data-mp="po2bcpngycda" />
          <p className="text-xs tracking-widest text-text-muted mt-3" data-id="element-33" data-mp="yp9x688stkqh">Homes</p>
        </div>
      </motion.div>
    </section>;
}